import React, { useContext } from 'react';
import { useFocusManager } from '@react-aria/focus';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { getTargetSimple } from './NavbarHelpers.js';
import { NavbarContext } from './NavbarContext.js';

const NavbarMobileHelpItem = (props) => {
    const { helpUrl, linkWrapper, target } = props;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const focusManager = useFocusManager();
    const { setShowMobileMenu } = useContext(NavbarContext);
    const handleKeyDown = (e) => {
        if (!focusManager)
            return;
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                focusManager.focusNext({ wrap: true });
                break;
            case 'ArrowUp':
                e.preventDefault();
                focusManager.focusPrevious({ wrap: true });
                break;
            case 'End':
                e.preventDefault();
                focusManager.focusLast({});
                break;
            case 'Home':
                e.preventDefault();
                focusManager.focusFirst({});
                break;
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'helix-unified-navbar__mobile-menu-item helix-unified-navbar__mobile-menu-help-item' },
            React.createElement(React.Fragment, null, linkWrapper ? (React.cloneElement(linkWrapper({
                url: helpUrl,
                props: {
                    onKeyDown: (e) => handleKeyDown(e),
                    onClick: (e) => {
                        setShowMobileMenu(false);
                    }
                },
                label: (React.createElement(React.Fragment, null,
                    React.createElement(NavbarHelixIcon, { iconName: 'question_help' }),
                    " Help"))
            }), {
                onKeyDown: (e) => handleKeyDown(e),
                onClick: (e) => {
                    setShowMobileMenu(false);
                }
            })) : (React.createElement("a", Object.assign({ onKeyDown: (e) => handleKeyDown(e), href: helpUrl, onClick: (e) => {
                    setShowMobileMenu(false);
                } }, getTargetSimple(target)),
                React.createElement(NavbarHelixIcon, { iconName: 'question_help' }),
                " Help"))))));
};

export { NavbarMobileHelpItem as default };
//# sourceMappingURL=NavbarMobileHelpItem.js.map
